export const FILTER_TYPE = {
  MULTI_SELECT: "MULTI_SELECT",
  DATE_RANGE: "DATE_RANGE",
  SLIDER: "slider",
}

export const getDropdownOptions = (options, ...params) => [
  ...options(...params),
]
